import dynamic from 'next/dynamic';

import SanityPage from './SanityPage';
import { SanityPageProps } from './withSanityPageProps';
import { PortableText, Serializers, SerializerContext } from './serializers';

// this is to avoid SSR issues
const PreviewPageBuilder = dynamic(() => import('./PreviewPageBuilder'), {
  ssr: false,
});

export type PageBuilderProps = SanityPageProps & {
  serializers?: Serializers;
};

/**
 * Represents a Sanity backed page that makes use of the PortableText based page
 * builder functionality.
 *
 * In next-sanity v5, preview functionality is handled by a separate client-only component
 * to avoid SSR/hydration issues with LiveQueryProvider.
 */
export default function PageBuilder({ data, preview, token, serializers }: PageBuilderProps) {
  const serializerOptions = {
    serializers,
    data: data.static,
  };

  // Non-preview mode: render normally (server-side compatible)
  if (!preview) {
    return (
      <SanityPage data={data} preview={false}>
        <SerializerContext.Provider value={serializerOptions}>
          <PortableText content={data.page?.pageBuilder ?? []} />
        </SerializerContext.Provider>
      </SanityPage>
    );
  }

  // Preview mode: use client-only component
  return <PreviewPageBuilder data={data} preview={preview} token={token} serializers={serializers} />;
}
